import React from 'react'
import { HBox, Wrapper } from 'src/ui/layout'
import { Hero } from 'src/ui/organisms'
import { styled } from 'src/ui/theme'
import { Body, Label } from 'src/ui/typography'

const StyledLabel = styled(Label)`
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
`

const StyledLabelScore = styled(Label)`
  font-weight: 900;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.brand.primary};
`

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

type Props = {
  images: TImages
}

export const Score = ({ images }: Props) => {
  return (
    <>
      <HBox />

      <Hero
        label={
          <>
            <LabelContainer>
              <StyledLabel>индекс eNps</StyledLabel>
              <StyledLabelScore>4,6/5 баллов</StyledLabelScore>
            </LabelContainer>
            <HBox height={8} />
          </>
        }
        title="Лучшие люди делают лучшую работу"
        background={images['score-mob']}
      >
        <HBox height={24} />

        <Body>
          В KODE люди важнее проектов, а процессы существуют, чтобы помогать
          людям. <br /> <br /> Эта ценность стала основой нашего HR-бренда.
        </Body>

        <HBox height={8} />
      </Hero>
    </>
  )
}
